import React from "react"
import {
  PlayCircle as BootstrapPlayCircle,
  PlusCircle as BootstrapPlusCircle,
} from "react-bootstrap-icons"

export const PlayCircle = ({
  disabled = false,
  className = "",
  onClick,
  ...props
}) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    if (onClick) {
      onClick(e)
    }
  }

  const disabledClass = disabled
    ? "text-gray-400 cursor-not-allowed"
    : "cursor-pointer"
  const combinedClassName = `${className} ${disabledClass}`.trim()

  return (
    <BootstrapPlayCircle
      className={combinedClassName}
      onClick={handleClick}
      {...props}
    />
  )
}

export const PlusCircle = ({
  disabled = false,
  className = "",
  onClick,
  ...props
}) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    if (onClick) {
      onClick(e)
    }
  }

  const disabledClass = disabled
    ? "text-gray-400 cursor-not-allowed"
    : "cursor-pointer"
  const combinedClassName = `${className} ${disabledClass}`.trim()

  return (
    <BootstrapPlusCircle
      className={combinedClassName}
      onClick={handleClick}
      {...props}
    />
  )
}
